import { render } from "./device_details.vue?vue&type=template&id=60236b31&scoped=true"
import script from "./device_details.vue?vue&type=script&lang=js"
export * from "./device_details.vue?vue&type=script&lang=js"

import "./device_details.vue?vue&type=style&index=0&id=60236b31&lang=css"
import "./device_details.vue?vue&type=style&index=1&id=60236b31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60236b31"]])

export default __exports__